import { VisitationRotationBlock } from "../models/VisitationRotationBlock";
import { RotationDayEditor } from "./RotationDayEditor";

interface VisitationEditorProps {
  startDate: string;
  rotation: { [key: number]: VisitationRotationBlock };
  setRotation: React.Dispatch<
    React.SetStateAction<{ [key: number]: VisitationRotationBlock }>
  >;
}

const VisitationEditor = ({
  startDate,
  rotation,
  setRotation,
}: VisitationEditorProps) => {
  const handleBlockUpdate = (
    dayOffset: number,
    updatedBlock: VisitationRotationBlock,
  ) => {
    setRotation((prev) => ({
      ...prev,
      [dayOffset]: updatedBlock,
    }));
  };

  return (
    <>
      {Object.entries(rotation ?? {}).map(([index, block]) => (
        <RotationDayEditor
          key={index}
          block={block}
          dayOffset={Number(index)}
          startDate={startDate}
          onChange={(updated) => handleBlockUpdate(Number(index), updated)}
        />
      ))}
    </>
  );
};

export default VisitationEditor;
